module.exports = __webpack_public_path__ + "img/952-f59393.png";